const ARIAL_STACK = `'Arial Web', Arial, sans-serif`;

const getFontFamilyCss = () => `
  :root,
  html,
  body,
  * {
    font-family: ${ARIAL_STACK} !important;
  }
`;

export default getFontFamilyCss;
